import { Flex } from "@radix-ui/themes";

import { AutomationConfigurationContentHeader } from "../parts/AutomationConfigurationContentHeader";
import { ArticleLinksField } from "../parts/ArticleLinksField";
import { SlackChannelInstallSimulator } from "./SlackChannelInstallSimulator";

export function SlackChannelGeneralConfiguration() {
  return (
    <Flex direction={"column"} gap={"24px"}>
      <AutomationConfigurationContentHeader title={"General"} status={"idle"} />

      <Flex direction={"column"}>
        <ArticleLinksField />
      </Flex>

      <SlackChannelInstallSimulator />
    </Flex>
  );
}
